export const create = (
  value: string,
  prefix: string = '',
  suffix: string = '',
  editable: boolean = false,
) => {
  const tinymce = (window as any).tinymce;

  const mergeTag = tinymce.html.Node.create('span', {
      class: 'pm-merge-tag',
      contenteditable: editable ? 'true' : 'false',
      'data-pm-merge-tag': '1', // used as a selector only
    });
  const mergeTagText = tinymce.html.Node.create("#text");
  mergeTagText.value = value;

  const prefixNode = tinymce.html.Node.create('span', {
    class: 'pm-merge-tag-affix',
    'data-pm-merge-tag-affix': '1',
  });
  const prefixText = tinymce.html.Node.create("#text");
  prefixText.value = prefix;
  prefixNode.append(prefixText);

  const suffixNode = tinymce.html.Node.create('span', {
    class: 'pm-merge-tag-affix',
    'data-pm-merge-tag-affix': '1',
  });
  const suffixText = tinymce.html.Node.create("#text");
  suffixText.value = suffix;
  suffixNode.append(suffixText);

  mergeTag.append(prefixNode);
  mergeTag.append(mergeTagText);
  mergeTag.append(suffixNode);

  return mergeTag;
}
